namespace GeniuzPOS.Purchase {
    export interface ReportDailyPIRow {
        Id?: string;
        SysDocNo?: string;
        PurIvNo?: string;
        DocDate?: string;
        SupplierId?: string;
        SupplName?: string;
        RefDocNo1?: string;
        PayTermCode?: string;
        DueDate?: string;
        WhsId?: string;
        TotalAmt?: number;
        DiscAmt?: number;
        NetAmt?: number;
        VatAmt?: number;
        ExciseTaxAmt?: number;
        PurInvoiceAmt?: number;
        DepositAmt?: number;
        DtList?: PoPurInvoiceDtRow[];
    }

    export namespace ReportDailyPIRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.ReportDailyPI';
        export const lookupKey = 'Purchase.ReportDailyPI';

        export function getLookup(): Q.Lookup<ReportDailyPIRow> {
            return Q.getLookup<ReportDailyPIRow>('Purchase.ReportDailyPI');
        }
        export const deletePermission = '5Purchase:รายงาน:รายงานรายวันใบอินวอยว์ซื้อ:View';
        export const insertPermission = '5Purchase:รายงาน:รายงานรายวันใบอินวอยว์ซื้อ:View';
        export const readPermission = '5Purchase:รายงาน:รายงานรายวันใบอินวอยว์ซื้อ:View';
        export const updatePermission = '5Purchase:รายงาน:รายงานรายวันใบอินวอยว์ซื้อ:View';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            PurIvNo = "PurIvNo",
            DocDate = "DocDate",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            RefDocNo1 = "RefDocNo1",
            PayTermCode = "PayTermCode",
            DueDate = "DueDate",
            WhsId = "WhsId",
            TotalAmt = "TotalAmt",
            DiscAmt = "DiscAmt",
            NetAmt = "NetAmt",
            VatAmt = "VatAmt",
            ExciseTaxAmt = "ExciseTaxAmt",
            PurInvoiceAmt = "PurInvoiceAmt",
            DepositAmt = "DepositAmt",
            DtList = "DtList"
        }
    }
}
